
import { Fraga } from "@/types/riskbedomning";
import { groundRiskFragor } from "./groundRisks";
import { heightRiskFragor } from "./heightRisks";
import { waterRiskFragor } from "./waterRisks";
import { chemicalRiskFragor } from "./chemicalRisks";
import { electricalRiskFragor } from "./electricalRisks";
import { constructionRiskFragor } from "./constructionRisks";
import { trafficRiskFragor } from "./trafficRisks";
import { radiationRiskFragor } from "./radiationRisks";
import { blastingRiskFragor } from "./blastingRisks";

// Combine all specialized risk questions - exactly 13 according to AFS
export const specialRiskFragor: Fraga[] = [
  ...groundRiskFragor,          // 2: mark-ras, trånga utrymmen
  ...heightRiskFragor,          // 1: fallrisk >2m
  ...waterRiskFragor,           // 3: drunkning, dykarbete, kassunarbete
  ...chemicalRiskFragor,        // 1: kemiska/biologiska ämnen
  ...radiationRiskFragor,       // 1: joniserande strålning
  ...blastingRiskFragor,        // 1: sprängningsarbeten
  ...electricalRiskFragor,      // 1: högspänning
  ...constructionRiskFragor,    // 2: tunga element, rivning
  ...trafficRiskFragor          // 1: fordonstrafik
  // Total: 13 särskilda arbetsmiljörisker
];
